import { useEffect, useState } from "react";

function diff(target) {
  const total = Math.max(new Date(target).getTime() - Date.now(), 0);
  return {
    total,
    days: Math.floor(total / 86400000),
    hours: Math.floor((total / 3600000) % 24),
    minutes: Math.floor((total / 60000) % 60),
    seconds: Math.floor((total / 1000) % 60),
  };
}

export function Countdown({ endsAt, className = "", dark = false, testId = "countdown" }) {
  const [left, setLeft] = useState(() => diff(endsAt));

  useEffect(() => {
    setLeft(diff(endsAt));
    const timer = setInterval(() => setLeft(diff(endsAt)), 1000);
    return () => clearInterval(timer);
  }, [endsAt]);

  if (!endsAt || left.total <= 0) return null;

  const blocks = [
    { value: left.days, label: "J" },
    { value: left.hours, label: "H" },
    { value: left.minutes, label: "M" },
    { value: left.seconds, label: "S" },
  ];

  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid={testId}>
      {blocks.map((block) => (
        <span
          key={block.label}
          className={`flex min-w-[38px] flex-col items-center rounded-lg px-1.5 py-1 ${
            dark ? "bg-white/10 text-white" : "bg-ink text-white"
          }`}
        >
          <span className="font-display text-sm font-extrabold leading-none tabular-nums">
            {String(block.value).padStart(2, "0")}
          </span>
          <span className="text-[8px] font-bold uppercase tracking-wider opacity-70">{block.label}</span>
        </span>
      ))}
    </div>
  );
}

export default Countdown;
